<template>
  <div></div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

import { useAccountStore } from "@/stores/account"
import { useAuthenticationStore } from "@/stores/authentication"
import { useEstablishmentStore } from "@/stores/establishment"
import { mapStores } from "pinia"
import { getAccessPlanCode } from "@/utils/contract"

export default defineComponent({
  name: "ReloadIntercom",

  data() {
    return {
      intercomId: import.meta.env.VITE_INTERCOM_ID,
    }
  },

  computed: {
    ...mapStores(useAccountStore, useAuthenticationStore, useEstablishmentStore),
    isDemoEstablishment(): boolean {
      return getAccessPlanCode(this.establishmentStore.currentEstablishment) === "DEMO"
    },
  },

  watch: {
    $route(to, from) {
      this.handleIntercom(to)
    },
    "accountStore.hasPremium"() {
      this.handleIntercom(this.$route)
    },
    isDemoEstablishment() {
      this.handleIntercom(this.$route)
    },
    "authenticationStore.isSaleOnly"() {
      this.handleIntercom(this.$route)
    },
  },

  mounted() {
    if (!this.authenticationStore.isSaleOnly) {
      this.loadIntercom()
    }
    this.handleIntercom(this.$route)
  },

  methods: {
    isIntercomReady() {
      return typeof window.Intercom === "function"
    },

    setIntercomContainerVisibility(hidden: boolean) {
      const container = document.getElementsByClassName("intercom-lightweight-app")[0] as HTMLElement | undefined
      if (container) {
        container.style.display = hidden ? "none" : "initial"
      }
    },

    loadIntercom() {
      let script = document.createElement("script")
      script.setAttribute("src", "/intercom.js")
      script.setAttribute("id", "intercom-script")
      document.head.appendChild(script)

      // Evite le clignotement du launcher avant décision d'affichage.
      this.setIntercomContainerVisibility(true)

      setTimeout(() => {
        const intercomConfig = {
          app_id: this.intercomId,
          alignment: "right",
          horizontal_padding: 30,
          vertical_padding: 30,
          platform: "USKA",
          // Launcher flottant remplacé par le bouton header (évite les collisions UI).
          hide_default_launcher: true,
        }

        if (window.intercomSettings === undefined) {
          window.intercomSettings = {}
        }

        Object.assign(window.intercomSettings, intercomConfig)

        if (this.isIntercomReady()) {
          window.Intercom("boot", window.intercomSettings)
        }
        this.handleIntercom(this.$route)
      }, 1000)
    },

    applyIntercomVisibility(shouldDisableIntercom: boolean) {
      if (window.intercomSettings === undefined) {
        window.intercomSettings = {}
      }

      Object.assign(window.intercomSettings, {
        hide_default_launcher: true,
      })

      if (this.isIntercomReady()) {
        window.Intercom("update", window.intercomSettings)
        if (shouldDisableIntercom) {
          window.Intercom("hide")
        }
      }

      this.setIntercomContainerVisibility(shouldDisableIntercom)
    },

    handleIntercom(to?: any) {
      const shouldHideIntercom =
        this.authenticationStore.isSaleOnly ||
        this.isDemoEstablishment ||
        (to && to.meta.hideIntercom) ||
        !this.accountStore.hasPremium

      // Application immédiate + réapplication courte pour contrer les updates asynchrones.
      this.applyIntercomVisibility(shouldHideIntercom)
      window.setTimeout(() => this.applyIntercomVisibility(shouldHideIntercom), 300)
      window.setTimeout(() => this.applyIntercomVisibility(shouldHideIntercom), 1200)
    },
  },
})
</script>
